// Generated by Claude (Claude Code): https://claude.ai/code/session_01EL8pThQMncddrdNbSz5rkd
//
// The canonical, crawlable URL for an issue. These pages are rendered by the
// API server (artifacts/api-server/src/public-pages/), not by this app, so link
// to them with a plain <a href> — a client-side route would find nothing.
// Keep this in step with slugify()/displayTitle() in that package's html.ts;
// the server redirects a stale slug to the canonical one either way.

export function slugifyIssueTitle(text: string): string {
  return text
    .normalize("NFKD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 8)
    .join("-");
}

export function issuePageUrl(issue: { id: number; title: string }): string {
  const slug = slugifyIssueTitle(issue.title);
  return slug ? `/issues/${issue.id}-${slug}` : `/issues/${issue.id}`;
}
